import React from 'react';

const HealthRing = ({ current, target, color = 'gray', size = 60 }) => {
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const percentage = target > 0 ? Math.min((current / target) * 100, 100) : 0;
  const offset = circumference - (percentage / 100) * circumference;

  const colors = {
    green: 'text-emerald-500',
    amber: 'text-amber-500',
    gray: 'text-gray-200',
    pink: 'text-rutabaga-pink'
  };

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg className="transform -rotate-90" width={size} height={size}>
        <circle
          className="text-gray-100"
          strokeWidth={strokeWidth}
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          className={`${colors[color] || colors.gray} transition-all duration-1000 ease-out`}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
      </svg>
      <div className="absolute flex flex-col items-center justify-center">
        <span className="text-[10px] font-black text-rutabaga-dark leading-none">{current}</span>
        <div className="w-4 h-[1px] bg-gray-200 my-0.5"></div>
        <span className="text-[8px] font-black text-gray-400 leading-none">{target}</span>
      </div>
    </div>
  );
};

export default HealthRing;